import React, { CSSProperties } from "react";

import { InfoButton } from "./styled";
import { useProjectInfo } from "../../ducks/project/hooks";
import { useProjectInfoDialog } from "../../hooks/useDialogs";

export const ProjectInfoButton = ({ style }: { style?: CSSProperties }) => {
  const [project] = useProjectInfo();
  const openProjectInfo = useProjectInfoDialog();

  if (!project.content?.projectInfo || !Array.isArray(project.content.projectInfo)) return null;

  return <InfoButton style={style} onClick={() => openProjectInfo([""], { project })} />;
};
